var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"d-flex justify-center",staticStyle:{"height":"75%"}},[(_vm.widget.payload == '1')?_c('v-icon',{staticStyle:{"font-size":"100px"},attrs:{"color":_vm.Color}},[_vm._v(" "+_vm._s(_vm.getIcon)+" ")]):_c('v-icon',{staticStyle:{"font-size":"100px"}},[_vm._v(" "+_vm._s(_vm.getOutlineIcon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }